import script from "./goRinSyo0053.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0053.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0053.vue?vue&type=style&index=0&id=9ec00bc4&lang=scss"

const __exports__ = script;

export default __exports__